import { axios } from '../utilities';

const getPhotosAndResources = (userId, projectId) => axios.get('api/photos', { params: { userId, projectId } });

const addPhotoByProjectId = (projectId, photo) => axios.post('api/photos/add-photo', { projectId, photo });

const addMultiplePhotos = (projectId, photos) => axios.post('api/photos/batch', { projectId, photos });

const updateMultiplePhotos = photos => axios.put('api/photos/batch', { photos });

const updatePhoto = (photoId, photo, objectPositionAndZoom) => axios.put(`api/photos/single/${photoId}`, { photo, objectPositionAndZoom });

const deletePhotoWithIndexShifting = photoId => axios.delete(`api/photos/${photoId}`);

const sendPhotosUploadInfo = (projectId, photosCount, captionsCount) => axios.post('api/photos/send-photos-info', { projectId, photosCount, captionsCount });

const replaceCoverPhoto = photo => axios.put('api/photos/single/cover-photo/replace', { photo });

const removeAvatar = (userId, photoHandle) => axios.put(`api/photos/${userId}/remove-avatar`, { photoHandle });

const removeUnsavedUserAvatar = photoHandle => axios.put('api/photos/remove-unsaved-avatar', { photoHandle });

const chooseCoverPhoto = projectId => axios.put(`api/photos/${projectId}/choose-cover-photo`);

const getCoverPhotos = () => axios.get('api/photos/cover-photos');

const getCoverPhotosByProjectId = projectId => axios.get(`api/photos/cover-photos/project/${projectId}`);

const deleteCoverPhotos = photoIds => axios.delete('api/photos/delete-cover-photos', { data: photoIds });

const addCoverPhoto = (projectId, photo) => axios.post('api/photos/add-cover-photo', { projectId, photo });

export default {
  getPhotosAndResources,
  addPhotoByProjectId,
  addMultiplePhotos,
  updateMultiplePhotos,
  updatePhoto,
  deletePhotoWithIndexShifting,
  sendPhotosUploadInfo,
  replaceCoverPhoto,
  removeAvatar,
  removeUnsavedUserAvatar,
  chooseCoverPhoto,
  getCoverPhotos,
  getCoverPhotosByProjectId,
  deleteCoverPhotos,
  addCoverPhoto,
};
